import React from "react";
import styled from "styled-components";

const StyledCategoryItem = ({ onClick, isActive, title }) => {
  return (
    <StyledCategoryItemContain onClick={onClick} isActive={isActive}>
      {title}
    </StyledCategoryItemContain>
  );
};

export default StyledCategoryItem;

const StyledCategoryItemContain = styled.div`
  width: 175px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 400;

  letter-spacing: -0.6px;
  font-family: "LINESeedKR-Rg";

  color: #222222;

  border: ${(props) =>
    props.isActive ? "1px solid #5050FF" : "1px solid #A4A8B1"};
  background: ${(props) => (props.isActive ? "#5050FF" : "#fff")};

  border-radius: 12px;
  cursor: pointer;
  color: ${(props) => (props.isActive ? "#fff" : "#A4A8B1")};
  transition: all 0.3s ease;

  &:hover {
    border: 1px solid #5050ff;
    background: #5050ff;
    color: #fff !important;
  }
`;
